import styled from "styled-components";

export const ComboboxMultipleFooter = styled.div`
    border-top: 1px solid var(--wds-color-border);
    padding: 0.5rem;
`;
